import { useMemo } from 'react';
import { DynamicIcon } from 'src/components';
import { useRegisterQuickActions } from 'src/components/QuickActions/use-register-quick-actions';
import { Conversation } from 'src/graphql';
import { useConversationActions } from 'src/pages/Conversations/use-conversation-actions';

const GROUP_NAME = 'Conversation Actions';
const CONVERSATION_ACTION_ORDER = 200;

export const useConversationQuickActions = ({
  conversation,
  handleAfterDelete,
  customViewId = null,
}: {
  conversation: Conversation;
  handleAfterDelete?: () => void;
  customViewId?: string | null;
}) => {
  const {
    copyConversationId,
    copyFriendlyIdAsLink,
    copyUrl,
    copyConversationAsMarkdown,
    downloadConversationAsPdf,
    copyUuid,
    copyTOS,
    mergeConversation,
    deleteConversation,
    showActivityFeed,
  } = useConversationActions({
    conversation,
    handleAfterDelete,
    customViewId,
  });

  useRegisterQuickActions(
    useMemo(
      () =>
        [
          mergeConversation,
          deleteConversation,
          copyConversationId,
          copyUuid,
          copyFriendlyIdAsLink,
          copyUrl,
          copyTOS,
          copyConversationAsMarkdown,
          downloadConversationAsPdf,
          showActivityFeed,
        ]
          .filter((action) => ('isAllowed' in action ? action.isAllowed : true))
          .map((action) => ({
            id: `${action.label}-${CONVERSATION_ACTION_ORDER}`,
            title: action.label,
            icon: <DynamicIcon name={action.icon} library={action.iconLibrary} />,
            group: GROUP_NAME,
            handler: action.handler,
            order: CONVERSATION_ACTION_ORDER,
          })),
      [
        mergeConversation,
        deleteConversation,
        copyConversationId,
        copyUuid,
        copyTOS,
        copyFriendlyIdAsLink,
        copyUrl,
        copyConversationAsMarkdown,
        downloadConversationAsPdf,
        showActivityFeed,
      ],
    ),
  );
};
